import { asyncFetchData } from './fetch-data.js'
import data from '../data/stateId.js'

async function getStates(countryId) {
	// const { data } = await fetch(
	// 	`/koAddress/stateId.json`
	// 	// `/api/address/get-state-list-by-country-id?countryId=${countryId}`
	// )
	window.statesData = data
	return data
}

export function findStateId(nameString, statesDataArr = data.data) {
	for (const { id, name } of statesDataArr) {
		// console.debug(nameString, name)
		if (nameString === name) {
			return id
		}
	}
}

export default getStates
